import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import {
  inboxStatus,
  inboxMobileView,
  fetchInboxSortBy,
} from "venuescanner-js/constants/thread";

export const ViewContext = createContext({
  activeUser: null,
  setActiveUser: null,
  threadLoading: null,
  setThreadLoading: null,
  activeThread: null,
  setActiveThread: null,
  activeThreadStatus: null,
  setActiveThreadStatus: null,
  activeMatchEvent: null,
  setActiveMatchEvent: null,
  activeCurrency: null,
  setActiveCurrency: null,
  threadsFilter: [inboxStatus.NEW],
  setThreadsFilter: null,
  searchFilter: '',
  setSearchFilter: null,
  chatFilter: null,
  setChatFilter: null,
  isUserTyping: null,
  setIsUserTyping: null,
  isMobileDevice: null,
  setIsMobileDevice: null,
  isMonitor: null,
  setIsMonitor: null,
  activeMobileView: null,
  setActiveMobileView: null,
  isSearchActive: null,
  setIsSearchActive: null,
  threadsSort: fetchInboxSortBy.LAST_ACTION_DATE,
  setThreadsSort: null,
});

const ViewProvider = ({ children }) => {
  const [activeUser, setActiveUser] = useState(null);
  const [activeCurrency, setActiveCurrency] = useState(null);
  const [activeThread, setActiveThread] = useState(null);
  const [activeThreadStatus, setActiveThreadStatus] = useState(null);
  const [threadLoading, setThreadLoading] = useState(false);
  const [activeMatchEvent, setActiveMatchEvent] = useState(null);
  const [threadsFilter, setThreadsFilter] = useState([inboxStatus.NEW]);
  const [searchFilter, setSearchFilter] = useState('');
  const [chatFilter, setChatFilter] = useState(null);
  const [isUserTyping, setIsUserTyping] = useState(false);
  const [isMobileDevice, setIsMobileDevice] = useState(
    window.innerWidth < 1200
  );
  // see scss/stylesheets/settings/_vars.scss:$monitor: 1400px;
  const [isMonitor, setIsMonitor] = useState(window.innerWidth >= 1400);
  const [activeMobileView, setActiveMobileView] = useState(
    inboxMobileView.CHAT
  );

  const [isSearchActive, setIsSearchActive] = useState(false);
  const [threadsSort, setThreadsSort] = useState(
    fetchInboxSortBy.LAST_ACTION_DATE
  );

  return (
    <ViewContext.Provider
      value={{
        activeUser,
        setActiveUser,
        activeCurrency,
        setActiveCurrency,
        threadLoading,
        setThreadLoading,
        activeThread,
        setActiveThread,
        activeThreadStatus,
        setActiveThreadStatus,
        threadsFilter,
        setThreadsFilter,
        activeMatchEvent,
        setActiveMatchEvent,
        searchFilter,
        setSearchFilter,
        chatFilter,
        setChatFilter,
        isUserTyping,
        setIsUserTyping,
        isMobileDevice,
        setIsMobileDevice,
        isMonitor,
        setIsMonitor,
        activeMobileView,
        setActiveMobileView,
        isSearchActive,
        setIsSearchActive,
        threadsSort,
        setThreadsSort,
      }}
    >
      {children}
    </ViewContext.Provider>
  );
};

ViewProvider.propTypes = {
  children: PropTypes.node,
};

export default ViewProvider;
